import React, { useState } from "react"
import moment from "moment"
import Modal from "../../components/Modal"
import DatePicker from "../../components/Form/DatePicker"
import Select from "../../components/Form/Select"
import Button from "../../components/Form/Button"
import styles from "./outboundCampaignList.module.css"

const scheduleOptions = [
    { id: "next_slot", value: "Próximo intervalo disponível" },
    { id: "scheduled", value: "Escolher data e horário" },
]

const CampaignRetryModal = ({ eligible = 0, onSubmit, closeModal }) => {
    const initial = moment().add(1, "hour")
    const [mode, setMode] = useState("next_slot")
    const [date, setDate] = useState(initial.format("YYYY-MM-DD"))
    const [time, setTime] = useState(initial.format("HH:mm"))
    const [loading, setLoading] = useState(false)

    const handleSubmit = async event => {
        event.preventDefault()
        const scheduledAt = mode === "scheduled"
            ? moment(`${date} ${time}`, "YYYY-MM-DD HH:mm").toISOString()
            : undefined
        setLoading(true)
        try {
            await onSubmit(scheduledAt)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            title="Reenviar mensagens com falha"
            description={`${eligible} ${eligible === 1 ? "mensagem elegível" : "mensagens elegíveis"} para nova tentativa`}
            closeModal={closeModal}
            fitContent
        >
            <form className={styles.scheduleForm} onSubmit={handleSubmit}>
                <p>Somente as mensagens elegíveis serão reenviadas. Uma nova tentativa pode gerar cobrança adicional pela Meta.</p>
                <Select
                    name="Quando reenviar"
                    options={scheduleOptions}
                    selected={mode}
                    onChange={setMode}
                />
                {mode === "scheduled" && (
                    <DatePicker
                        name="Data e horário do reenvio"
                        dateStart={date}
                        timeStart={time}
                        min={moment().startOf("day")}
                        multiple={false}
                        showTime
                        onChange={(nextDate, _dateEnd, nextTime) => {
                            setDate(nextDate)
                            setTime(nextTime || time)
                        }}
                    />
                )}
                <div className={styles.modalActions}>
                    <Button type="submit" disabled={loading}>{loading ? "Preparando…" : mode === "scheduled" ? "Agendar reenvio" : "Reenviar no próximo intervalo"}</Button>
                    <Button type="button" variant="secondary" onClick={closeModal}>Cancelar</Button>
                </div>
            </form>
        </Modal>
    )
}

export default CampaignRetryModal
